import { capitalize, extractLazy, formatMoney } from "lib/helpers";

interface Props {
  data: { name: string; earnings: number }[];
  totalAmount: number;
  headerText: string | (() => string);
  columnTitle: (count: number) => string;
}

export function BarChart(props: Props) {
  const { data, totalAmount, headerText, columnTitle } = props;

  const dataLength = data.length;

  return (
    <>
      <div className="song-by-song-bar-chart">
        <h2>{extractLazy(headerText)}</h2>
        <div className="song-by-song-table-container">
          <div className="table-row">
            <div>{columnTitle(dataLength)}</div>
            <div>Total Earnings</div>
          </div>
          {data.map((x, i) => (
            <BarChartRow
              key={`row-${i}`}
              name={x.name}
              amount={x.earnings}
              index={i + 1}
              totalAmount={totalAmount}
            />
          ))}
        </div>
      </div>
    </>
  );
}

function BarChartRow(props: {
  name: string;
  amount: number;
  index: number;
  totalAmount: number;
}) {
  const { name: trackTitle, amount: trackAmount, totalAmount, index } = props;

  return (
    <>
      <div className="bar-chart-row">
        <div className="table-row">
          <b>{index}</b> &nbsp; {capitalize(trackTitle.toLocaleLowerCase())}
        </div>
        <div className="table-row">
          <Bar percentage={(trackAmount / totalAmount) * 100} />
          <div>${formatMoney(trackAmount, 0)}</div>
        </div>
      </div>
    </>
  );
}

function Bar(props: { percentage: number }) {
  const { percentage } = props;

  return (
    <>
      <div className="bar-chart-bar">
        <div
          className="filled-bar"
          style={{
            flexBasis: `${Math.round(percentage)}%`,
            width: `${Math.round(percentage)}%`,
          }}
        />
        <div
          className="remaining-bar"
          style={{
            flexBasis: `${Math.round(100 - percentage)}%`,
            width: `${Math.round(100 - percentage)}%`,
          }}
        />
      </div>
    </>
  );
}
